import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const homeownersInsuranceIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 9L12 2L21 9V11" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5 10V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H11" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M17 11L17 11.01" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z" fill="#222222"/>
  <path d="M17 22C14.5 22 13 20 13 17.5C13 15 17 11 17 11C17 11 21 15 21 17.5C21 20 19.5 22 17 22Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
);
